import { render, staticRenderFns } from "./HealthReportNavigatorPanel.vue?vue&type=template&id=63407258"
import script from "./HealthReportNavigatorPanel.vue?vue&type=script&lang=ts"
export * from "./HealthReportNavigatorPanel.vue?vue&type=script&lang=ts"
import style0 from "./HealthReportNavigatorPanel.vue?vue&type=style&index=0&id=63407258&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports